export const translations = {
  es: {
    menu: {
      inicio: 'Inicio',
      acerca: 'Acerca del Concejo',
      noticias: 'Noticias',
      documentos: 'Documentos',
      transparencia: 'Transparencia',
      participacion: 'Participación',
      servicios: 'Servicios',
      contacto: 'Contacto',
      descConoce: 'Conoce el Concejo',
      descInformacion: 'Información y actualidad',
      descGaceta: 'Gaceta y documentos oficiales',
      descAcceso: 'Acceso a la información pública',
      descParticipa: 'Participa y opina',
      descTramites: 'Trámites y servicios',
      // Submenú Acerca
      mision: 'Misión',
      vision: 'Visión',
      estructuraJerarquica: 'Estructura Jerárquica',
      autoridades: 'Autoridades',
      historia: 'Historia',
      planAccion2025: 'Plan de Acción 2025',
      simbolos: 'Símbolos',
      // Submenú Noticias
      todasNoticias: 'Todas las Noticias',
      noticiasGenerales: 'Noticias Generales',
      sesionesConcejo: 'Sesiones del Concejo',
      acuerdosResoluciones: 'Acuerdos y Resoluciones',
      comunicadosOficiales: 'Comunicados Oficiales',
      eventosActividades: 'Eventos y Actividades',
      institucional: 'Institucional',
      // Submenú Documentos
      gacetaMunicipal: 'Gaceta Municipal',
      acuerdos: 'ACUERDOS',
      actasSesion: 'ACTAS DE SESIÓN',
      decretos: 'DECRETOS',
      proyectos: 'PROYECTOS',
      manuales: 'MANUALES',
      planes: 'PLANES',
      reglamentoInterno: 'REGLAMENTO INTERNO',
      leyes: 'LEYES',
      politicas: 'POLÍTICAS',
      repositorio: 'REPOSITORIO',
      // Submenú Transparencia
      presupuesto: 'Presupuesto',
      contratacionPublica: 'Contratación Pública',
      planAnualCompras: 'Plan Anual de Compras',
      rendicionCuentas: 'Rendición de Cuentas',
      estadosFinancieros: 'Estados Financieros',
      controlInterno: 'Control Interno',
      declaracionRenta: 'Declaración de Renta',
      estructuraOrganizacional: 'Estructura Organizacional',
      planDesarrollo: 'Plan de Desarrollo',
      normatividad: 'Normatividad',
      serviciosCiudadanos: 'Servicios Ciudadanos',
      auditorias: 'Auditorías',
      bienesInmuebles: 'Bienes Inmuebles',
      personal: 'Personal',
      // Submenú Participación
      encuestas: 'Encuestas',
      foros: 'Foros',
      sesiones: 'Sesiones',
      convocatorias: 'Convocatorias',
      // Submenú Servicios
      tramites: 'Trámites',
      galeria: 'Galería'
    },
    home: {
      titulo: 'Concejo Municipal de Guachucal',
      subtitulo: 'Trabajando por nuestro municipio',
      anuncios: 'Anuncios Importantes',
      buscar: 'Encuentra lo que necesitas en segundos',
      accesoRapido: 'Acceso Rápido',
      contacto: 'Contacto',
      gaceta: 'Gaceta',
      noticias: 'Noticias y Publicaciones',
      ubicacion: 'Ubicación Concejo Municipal de Guachucal',
      ubicacionLabel: 'Ubicación',
      telefono: 'Teléfono',
      email: 'Email',
      horarios: 'Horarios',
      // Cuadrícula de acceso rápido
      accesoAgendaCMP: 'Agenda CMP',
      accesoContratacion: 'Contratación',
      accesoDecRenta: 'Dec. Renta',
      accesoEjecPresupuestal: 'Ejec. Presupuestal',
      accesoEstFinancieros: 'Est. Financieros',
      accesoInformesControl: 'Informes Control Interno',
      accesoPqrsd: 'PQRSD',
      accesoLibroRegistro: 'Libro de registro',
      accesoPresupuesto: 'Presupuesto',
      accesoRendicionCuentas: 'Rendición de cuentas',
      accesoEntidades: 'Entidades',
      accesoEntesControl: 'Entes de control'
    },
    footer: {
      derechos: 'Todos los derechos reservados',
      contacto: 'Contacto',
      horario: 'Horario de Atención',
      enlaces: 'Enlaces de Interés'
    },
    accesibilidad: {
      titulo: 'Accesibilidad',
      aumentarTexto: 'Aumentar texto',
      disminuirTexto: 'Disminuir texto',
      escalaGrises: 'Escala de grises',
      altoContraste: 'Alto contraste',
      fuenteLegible: 'Fuente legible',
      subrayarEnlaces: 'Subrayar enlaces',
      restablecer: 'Restablecer'
    }
  },
  en: {
    menu: {
      inicio: 'Home',
      acerca: 'About the Council',
      noticias: 'News',
      documentos: 'Documents',
      transparencia: 'Transparency',
      participacion: 'Participation',
      servicios: 'Services',
      contacto: 'Contact',
      descConoce: 'Learn about the Council',
      descInformacion: 'Information and updates',
      descGaceta: 'Gazette and official documents',
      descAcceso: 'Access to public information',
      descParticipa: 'Participate and share your opinion',
      descTramites: 'Procedures and services',
      mision: 'Mission',
      vision: 'Vision',
      estructuraJerarquica: 'Hierarchical Structure',
      autoridades: 'Authorities',
      historia: 'History',
      planAccion2025: 'Action Plan 2025',
      simbolos: 'Symbols',
      todasNoticias: 'All News',
      noticiasGenerales: 'General News',
      sesionesConcejo: 'Council Sessions',
      acuerdosResoluciones: 'Agreements and Resolutions',
      comunicadosOficiales: 'Official Statements',
      eventosActividades: 'Events and Activities',
      institucional: 'Institutional',
      gacetaMunicipal: 'Municipal Gazette',
      acuerdos: 'AGREEMENTS',
      actasSesion: 'SESSION MINUTES',
      decretos: 'DECREES',
      proyectos: 'PROJECTS',
      manuales: 'MANUALS',
      planes: 'PLANS',
      reglamentoInterno: 'INTERNAL REGULATIONS',
      leyes: 'LAWS',
      politicas: 'POLICIES',
      repositorio: 'REPOSITORY',
      presupuesto: 'Budget',
      contratacionPublica: 'Public Procurement',
      planAnualCompras: 'Annual Procurement Plan',
      rendicionCuentas: 'Accountability',
      estadosFinancieros: 'Financial Statements',
      controlInterno: 'Internal Control',
      declaracionRenta: 'Tax Declaration',
      estructuraOrganizacional: 'Organizational Structure',
      planDesarrollo: 'Development Plan',
      normatividad: 'Regulations',
      serviciosCiudadanos: 'Citizen Services',
      auditorias: 'Audits',
      bienesInmuebles: 'Real Estate',
      personal: 'Personnel',
      encuestas: 'Surveys',
      foros: 'Forums',
      sesiones: 'Sessions',
      convocatorias: 'Calls',
      tramites: 'Procedures',
      galeria: 'Gallery'
    },
    home: {
      titulo: 'Municipal Council of Guachucal',
      subtitulo: 'Working for our municipality',
      anuncios: 'Important Announcements',
      buscar: 'Find what you need in seconds',
      accesoRapido: 'Quick Access',
      contacto: 'Contact',
      gaceta: 'Gazette',
      noticias: 'News and Publications',
      ubicacion: 'Location Municipal Council of Guachucal',
      ubicacionLabel: 'Location',
      telefono: 'Phone',
      email: 'Email',
      horarios: 'Hours',
      accesoAgendaCMP: 'CMP Agenda',
      accesoContratacion: 'Procurement',
      accesoDecRenta: 'Tax Return',
      accesoEjecPresupuestal: 'Budget Execution',
      accesoEstFinancieros: 'Financial Statements',
      accesoInformesControl: 'Internal Control Reports',
      accesoPqrsd: 'PQRSD',
      accesoLibroRegistro: 'Register Book',
      accesoPresupuesto: 'Budget',
      accesoRendicionCuentas: 'Accountability',
      accesoEntidades: 'Entities',
      accesoEntesControl: 'Oversight Bodies'
    },
    footer: {
      derechos: 'All rights reserved',
      contacto: 'Contact',
      horario: 'Opening Hours',
      enlaces: 'Links of Interest'
    },
    accesibilidad: {
      titulo: 'Accessibility',
      aumentarTexto: 'Increase text',
      disminuirTexto: 'Decrease text',
      escalaGrises: 'Grayscale',
      altoContraste: 'High contrast',
      fuenteLegible: 'Readable font',
      subrayarEnlaces: 'Underline links',
      restablecer: 'Reset'
    }
  },
  fr: {
    menu: {
      inicio: 'Accueil',
      acerca: 'À propos du Conseil',
      noticias: 'Actualités',
      documentos: 'Documents',
      transparencia: 'Transparence',
      participacion: 'Participation',
      servicios: 'Services',
      contacto: 'Contact',
      descConoce: 'Découvrez le Conseil',
      descInformacion: 'Information et actualités',
      descGaceta: 'Journal officiel et documents',
      descAcceso: 'Accès à l\'information publique',
      descParticipa: 'Participez et donnez votre avis',
      descTramites: 'Démarches et services',
      mision: 'Mission',
      vision: 'Vision',
      estructuraJerarquica: 'Structure hiérarchique',
      autoridades: 'Autorités',
      historia: 'Histoire',
      planAccion2025: 'Plan d\'action 2025',
      simbolos: 'Symboles',
      todasNoticias: 'Toutes les actualités',
      noticiasGenerales: 'Actualités générales',
      sesionesConcejo: 'Séances du Conseil',
      acuerdosResoluciones: 'Accords et résolutions',
      comunicadosOficiales: 'Communications officielles',
      eventosActividades: 'Événements et activités',
      institucional: 'Institutionnel',
      gacetaMunicipal: 'Journal officiel municipal',
      acuerdos: 'ACCORDS',
      actasSesion: 'PROCÈS-VERBAUX',
      decretos: 'DÉCRETS',
      proyectos: 'PROJETS',
      manuales: 'MANUELS',
      planes: 'PLANS',
      reglamentoInterno: 'RÈGLEMENT INTERNE',
      leyes: 'LOIS',
      politicas: 'POLITIQUES',
      repositorio: 'DÉPÔT',
      presupuesto: 'Budget',
      contratacionPublica: 'Marchés publics',
      planAnualCompras: 'Plan annuel d\'achats',
      rendicionCuentas: 'Reddition de comptes',
      estadosFinancieros: 'États financiers',
      controlInterno: 'Contrôle interne',
      declaracionRenta: 'Déclaration fiscale',
      estructuraOrganizacional: 'Structure organisationnelle',
      planDesarrollo: 'Plan de développement',
      normatividad: 'Réglementation',
      serviciosCiudadanos: 'Services aux citoyens',
      auditorias: 'Audits',
      bienesInmuebles: 'Immobilier',
      personal: 'Personnel',
      encuestas: 'Sondages',
      foros: 'Forums',
      sesiones: 'Séances',
      convocatorias: 'Appels',
      tramites: 'Démarches',
      galeria: 'Galerie'
    },
    home: {
      titulo: 'Conseil Municipal de Guachucal',
      subtitulo: 'Travailler pour notre municipalité',
      anuncios: 'Annonces importantes',
      buscar: 'Trouvez ce dont vous avez besoin en quelques secondes',
      accesoRapido: 'Accès rapide',
      contacto: 'Contact',
      gaceta: 'Journal officiel',
      noticias: 'Actualités et publications',
      ubicacion: 'Emplacement Conseil Municipal de Guachucal',
      ubicacionLabel: 'Emplacement',
      telefono: 'Téléphone',
      email: 'E-mail',
      horarios: 'Horaires',
      accesoAgendaCMP: 'Agenda CMP',
      accesoContratacion: 'Marchés',
      accesoDecRenta: 'Décl. fiscale',
      accesoEjecPresupuestal: 'Exéc. budgétaire',
      accesoEstFinancieros: 'États financiers',
      accesoInformesControl: 'Rapports contrôle interne',
      accesoPqrsd: 'PQRSD',
      accesoLibroRegistro: 'Livre de registre',
      accesoPresupuesto: 'Budget',
      accesoRendicionCuentas: 'Reddition de comptes',
      accesoEntidades: 'Entités',
      accesoEntesControl: 'Organes de contrôle'
    },
    footer: {
      derechos: 'Tous droits réservés',
      contacto: 'Contact',
      horario: 'Heures d\'ouverture',
      enlaces: 'Liens d\'intérêt'
    },
    accesibilidad: {
      titulo: 'Accessibilité',
      aumentarTexto: 'Augmenter le texte',
      disminuirTexto: 'Diminuer le texte',
      escalaGrises: 'Niveaux de gris',
      altoContraste: 'Contraste élevé',
      fuenteLegible: 'Police lisible',
      subrayarEnlaces: 'Souligner les liens',
      restablecer: 'Réinitialiser'
    }
  }
};
